<cs-standard-form #executeDocumentForm
  label="Execute Automation"
  cardClass="document-execution-card"
  text=""
  primaryButtonText="Execute"
  (submitted)="executeDocument()"
  (cancelled)="dialogRef.close()"
  [primaryButtonDisabled]="!isFormValid() || executeLoader">
  <!--Execution type -->
  <div class="document-execution--section">
    <h3 class="mb-1"><strong>Execution Type </strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="col-12 mt-2">
      <mat-radio-group name="execution-type-option"
        [(ngModel)]="executeDocumentObj.type">
        <div class="col-12 row-display flex-center no-padding">
          <div class="execution-type-option"
            [class.active-select]="executeDocumentObj.type === ExecutionType.Simple">
            <label class="dsp-flex">
              <mat-radio-button color="primary"
                [value]="ExecutionType.Simple"
                checked
              class="dsp-flex"></mat-radio-button>
              <div class="document-radio-button-option">
                <h3>Simple Execution</h3>
                <p>Execute this document against a single target.</p>
              </div>
            </label>
          </div>
          <div class="execution-type-option"
            [class.active-select]="executeDocumentObj.type === ExecutionType.RateControl">
            <label class="dsp-flex">
              <mat-radio-button color="primary"
                [value]="ExecutionType.RateControl"
                (change)="onExecutionTypeChange(ExecutionType.RateControl)"
              class="dsp-flex"></mat-radio-button>
              <div class="document-radio-button-option">
                <h3>Rate control</h3>
                <p>Execute this document against multiple targets while setting concurrency and error threshold limits.</p>
              </div>
            </label>
          </div>
        </div>
      </mat-radio-group>
    </div>
  </div>

  <!-- Document and Cloud Account -->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>Document and Cloud Account</strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="row mt-2">
      <div class="col-12 row-display">
        <div class="col-6 document-field-section-align">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Cloud Account</mat-label>
            <cs-select name="execute-cloud-account"
              preventDeselection
              [multiSelect]="false"
              [options]="cloudAccountOptions"
              [(ngModel)]="executeRequest.cloud_account_id"
              (valueChange)="onDocumentChange()"
              [readonly]="!!currentDocument.cloud_account_id"
              required/>
          </mat-form-field>
        </div>
        <div class="col-6 document-field-section-align">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Region</mat-label>
            <cs-select name="execute-regions"
              preventDeselection
              [multiSelect]="false"
              [options]="regionOptions"
              [(ngModel)]="executeRequest.region"
              (valueChange)="onDocumentChange()"
              [readonly]="!!currentDocument.region"
              required/>
          </mat-form-field>
        </div>
        <div class="col-6 document-field-section-align">
          <label class="fnt-lght mat-h5 m-0">Document Name</label>
          <p class="mat-h4 m-0"><strong>{{currentDocument.name}}</strong></p>
        </div>
        <div class="col-6 document-field-section-align">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Versions</mat-label>
            <cs-select name="document-version"
              preventDeselection
              [options]="versionOptions"
              [(ngModel)]="executeRequest.document_version"
              (ngModelChange)="findVersionRecord()"
              [multiSelect]="false"/>
          </mat-form-field>
        </div>
        <div class="col-6 document-field-section-align">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Change ID</mat-label>
            <input matInput
              autocomplete="off"
              type="text"
              name="executionChangeID"
              placeholder="Change ID"
              maxlength="100"
              [(ngModel)]="executeRequest.change_id"/>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- Targets -->
  @if (executeDocumentObj.type == ExecutionType.RateControl) {
    <div>
      <div class="document-execution--section mt-2">
        <h3 class="mb-1"><strong>Targets </strong></h3>
        <mat-divider class="cs-light-border"></mat-divider>
        @if (versionLoader) {
          <div class="container-width mt-2"
            >
            <div class="execution-container detail-page-card-padding">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
        }
        @if (!versionLoader) {
          <div>
            @if (versionRecord?.parameters?.length > 0) {
              <div class="row mt-2"
                >
                <div class="col-12 row-display no-padding">
                  <div class="col-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Parameter</mat-label>
                      <mat-hint class="fnt-lght">Choose the parameter that will define how your automation will branch out to additional targets.</mat-hint>
                      <cs-select name="target-input-parameters"
                        preventDeselection
                        [options]="parameterOptions"
                        [(ngModel)]="executeRequest.target_parameter_name"
                        (ngModelChange)="triggerTargetOptions()"
                        [multiSelect]="false"
                        required/>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="outline">
                      <mat-label>Target</mat-label>
                      <cs-select name="target-values"
                        preventDeselection
                        [options]="targetOptions"
                        [(ngModel)]="executeDocumentObj.selectedTargetValue"
                        (ngModelChange)="triggerTargetOptions()"
                        [multiSelect]="false"
                        required/>
                    </mat-form-field>
                  </div>
                </div>
                @if (executeDocumentObj.selectedTargetValue === 'ResourceGroup') {
                  <div class="col-12 row-display mt-2"
                    >
                    @if (!!executeRequest.cloud_account_id && !!executeRequest.region) {
                      <mat-form-field appearance="outline">
                        <mat-label>Resource Group</mat-label>
                        <cs-select name="targetResourceGroup"
                          preventDeselection
                          [options]="resGrpOptions"
                          emptyValueText="Select resource group"
                          [(ngModel)]="executeDocumentObj.targetObj.resourceGroup"
                          [multiSelect]="false"
                          required/>
                      </mat-form-field>
                    } @else {
                      <mat-error>Please select a cloud account and region to get a list of available resource groups.</mat-error>
                    }
                  </div>
                }
                @if (executeDocumentObj.selectedTargetValue === 'All Instances') {
                  <div class="col-12 row-display mt-2"
                    >
                    <mat-form-field appearance="outline">
                      <mat-label>All Instances</mat-label>
                      <input matInput
                        autocomplete="off"
                        type="text"
                        name="targetInstances"
                        [(ngModel)]="executeDocumentObj.targetObj.allInstances"
                        disabled
                        required/>
                    </mat-form-field>
                  </div>
                }
                @if (executeDocumentObj.selectedTargetValue === 'Tags') {
                  <div class="col-12 row-display mt-2"
                    >
                    <h3><strong>Tags</strong></h3>
                    <div class="col-12 no-padding row-display">
                      <div class="col-5">
                        <mat-form-field appearance="outline">
                          <mat-label>Tag Key</mat-label>
                          <input matInput
                            type="text"
                            name="targetObjTagKey"
                            placeholder="Key"
                            minlength="1"
                            maxlength="127"
                            [(ngModel)]="executeDocumentObj.targetObj.tagKey"/>
                        </mat-form-field>
                      </div>
                      <div class="col-5">
                        <mat-form-field appearance="outline">
                          <mat-label>Tag Value</mat-label>
                          <input matInput
                            type="text"
                            name="targetObjTagValue"
                            placeholder="Value"
                            minlength="1"
                            maxlength="255"
                            [(ngModel)]="executeDocumentObj.targetObj.tagValue"/>
                        </mat-form-field>
                      </div>
                      <div class="col-2 tag-action">
                        <cs-icon-button
                          [disabled]="executeDocumentObj.targetObj.tagsList.length >= 1 || !executeDocumentObj.targetObj.tagKey || !executeDocumentObj.targetObj.tagValue"
                          (buttonClick)="addTargetTags()"
                          icon="add_circle"
                          buttonStyle="tertiary"/>
                      </div>
                    </div>
                    <div class="col-md-12 row-display">
                      <mat-chip-listbox>
                        @for (tagObj of executeDocumentObj.targetObj.tagsList; track tagObj) {
                          <mat-chip class="cs-bg-clr-selected-blue"
                            (removed)="removeTags(tagObj, 'target')">
                            <span>{{tagObj.key}}:{{tagObj.value}}</span>
                            <div matChipRemove>
                              <mat-icon fontSet="cs-icon"
                              fontIcon="cs-icon-close-circle"></mat-icon>
                            </div>
                          </mat-chip>
                        }
                      </mat-chip-listbox>
                    </div>
                  </div>
                }
              </div>
            }
            @if (!versionRecord?.parameters || versionRecord?.parameters.length == 0) {
              <div class="col-12 mt-2 no-padding"
                >
                <p class="fnt-lght">No Targets available</p>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- Parameters -->
  <div class="document-execution--section mt-2">
    @if (!versionRecord?.parameters || versionRecord?.parameters.length == 0) {
      <div>
        <h3 class="mb-1"><strong>Input Parameters</strong></h3>
        <mat-divider class="cs-light-border"></mat-divider>
        @if (versionLoader) {
          <div class="container-width mt-2"
            >
            <div class="execution-container detail-page-card-padding">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
        }
        @if (!versionLoader) {
          <div class="col-12 mt-2 no-padding"
            >
            <p class="fnt-lght">No Input Parameters available.</p>
          </div>
        }
      </div>
    }
    @if (versionRecord?.parameters?.length > 0) {
      <div>
        <cs-input-parameters [parameters]="versionRecord.parameters"
          (valueChange)="inputParametersState.formattedModelValue = $event"
          [executionType]="executeDocumentObj.type"
          [paramValue]="executeRequest.target_parameter_name"
          [targetValue]="executeDocumentObj.selectedTargetValue"
          [(currentModelValue)]="inputParametersState.currentModelValue"
          (inputParamValid)="executeDocumentObj.isInpParamsValid = $event"
          (formValidChange)="inputParametersState.valid = $event">
        </cs-input-parameters>
      </div>
    }
  </div>

  <!-- Rate Control -->
  @if (executeDocumentObj.type === ExecutionType.RateControl) {
    <div class="document-execution--section mt-2"
      >
      <h3 class="mb-1"><strong>Rate Control </strong></h3>
      <mat-divider class="cs-light-border"></mat-divider>
      <div class="col-12 mt-2">
        <div class="col-12 row-display flex-center no-padding">
          <div class="col-6 row-display">
            <p><strong>Concurrency </strong></p>
            <p class="fnt-lght rate-control-option-height">Specify the number or percentage of targets to execute the task on at the same time.</p>
            <mat-radio-group name="concurrency-option"
              [(ngModel)]="executeDocumentObj.maxConcurrencyOption">
              <div class="col-12 row-display no-padding">
                <div class="execute-type-rate-control-option col-6 no-padding">
                  <mat-radio-button color="primary"
                    [value]="ConcurrencyOptions.Targets"
                    checked
                  class="dsp-flex"></mat-radio-button>
                  <mat-form-field appearance="outline"
                    class="mat-field-inp">
                    <mat-label>Targets</mat-label>
                    <input matInput
                      type="number"
                      name="concurrency_target"
                      min="1"
                      step="1"
                      [required]="executeDocumentObj.maxConcurrencyOption === ConcurrencyOptions.Targets"
                      [disabled]="executeDocumentObj.maxConcurrencyOption === ConcurrencyOptions.Percentage"
                      [(ngModel)]="executeDocumentObj.maxConcurrencyTarget"/>
                  </mat-form-field>
                </div>
                <div class="execute-type-rate-control-option col-6">
                  <mat-radio-button color="primary"
                    [value]="ConcurrencyOptions.Percentage"
                  class="dsp-flex"></mat-radio-button>
                  <mat-form-field appearance="outline"
                    class="mat-field-inp">
                    <mat-label>Percentage</mat-label>
                    <input matInput
                      type="number"
                      #concurrencyPercentage=ngModel
                      name="concurrency_percentage"
                      min="1"
                      max="100"
                      step="1"
                      [required]="executeDocumentObj.maxConcurrencyOption === ConcurrencyOptions.Percentage"
                      [disabled]="executeDocumentObj.maxConcurrencyOption === ConcurrencyOptions.Targets"
                      [(ngModel)]="executeDocumentObj.maxConcurrencyPercentage"/>
                    @if (concurrencyPercentage.touched && concurrencyPercentage.errors?.max) {
                      <mat-error>
                        The max. percentage allowed is '100'.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </mat-radio-group>
          </div>
          <div class="col-6 border-left-light-gray row-display pl-2">
            <p class="col-12 p-0"><strong>Error Threshold</strong></p>
            <p class="fnt-lght rate-control-option-height">Stop the task after it fails on a specific number of targets.</p>
            <mat-radio-group name="error-option"
              [(ngModel)]="executeDocumentObj.maxErrorsOption">
              <div class="col-12 row-display no-padding ">
                <div class="execute-type-rate-control-option col-6 no-padding">
                  <mat-radio-button color="primary"
                    [value]="ErrorOptions.Errors"
                    class="dsp-flex"
                  checked></mat-radio-button>
                  <mat-form-field appearance="outline"
                    class="mat-field-inp">
                    <mat-label>Errors</mat-label>
                    <input matInput
                      type="number"
                      name="errors_value"
                      min="0"
                      step="1"
                      [disabled]="executeDocumentObj.maxErrorsOption === ErrorOptions.Percentage"
                      [required]="executeDocumentObj.maxErrorsOption === ErrorOptions.Errors"
                      [(ngModel)]="executeDocumentObj.maxErrors"/>
                  </mat-form-field>
                </div>
                <div class="execute-type-rate-control-option col-6">
                  <mat-radio-button color="primary"
                    [value]="ErrorOptions.Percentage"
                  class="dsp-flex"></mat-radio-button>
                  <mat-form-field appearance="outline"
                    class="mat-field-inp">
                    <mat-label>Percentage</mat-label>
                    <input matInput
                      type="number"
                      #errorPercentage=ngModel
                      name="errors_percentage"
                      min="0"
                      max="100"
                      step="1"
                      [disabled]="executeDocumentObj.maxErrorsOption === ErrorOptions.Errors"
                      [required]="executeDocumentObj.maxErrorsOption === ErrorOptions.Percentage"
                      [(ngModel)]="executeDocumentObj.maxErrorsPercentage"/>
                    @if (errorPercentage.touched && errorPercentage.errors?.max) {
                      <mat-error>
                        The max. percentage allowed is '100'.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Tags -->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>Tags </strong></h3>
    <mat-hint> Max. 5 Tags can be added</mat-hint>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="row mt-2">
      <div class="col-12 row-display no-padding">
        <div class="col-5">
          <mat-form-field appearance="outline">
            <mat-label>Tag Key</mat-label>
            <input matInput
              type="text"
              name="tagKey"
              placeholder="Tag Key"
              minlength="1"
              maxlength="127"
              [(ngModel)]="executeDocumentObj.tagKey"/>
          </mat-form-field>
        </div>
        <div class="col-5">
          <mat-form-field appearance="outline">
            <mat-label>Tag Value</mat-label>
            <input matInput
              type="text"
              name="tagValue"
              placeholder="Tag Value"
              [required]="executeDocumentObj.tagKey ? true: false"
              minlength="1"
              maxlength="255"
              [(ngModel)]="executeDocumentObj.tagValue"/>
          </mat-form-field>
        </div>
        <div class="col-2 tag-action">
          <cs-icon-button
            [disabled]="executeDocumentObj.tagsList.length >= 5 || !executeDocumentObj.tagKey || !executeDocumentObj.tagValue"
            (buttonClick)="addTags()"
            icon="add_circle"
            buttonStyle="tertiary"/>
        </div>
      </div>
      @if (executeDocumentObj.isTagDuplicate) {
        <div
          class="col-12 row-display">
          <p class="clr-red">Tag Key must be unique</p>
        </div>
      }
      <div class="col-md-12 row-display">
        <mat-chip-listbox>
          @for (tagObj of executeDocumentObj.tagsList; track tagObj) {
            <mat-chip class="cs-bg-clr-selected-blue"
              (removed)="removeTags(tagObj, 'execution')">
              <span>{{tagObj.key}}:{{tagObj.value}}</span>
              <div matChipRemove>
                <mat-icon fontSet="cs-icon"
                fontIcon="cs-icon-close-circle"></mat-icon>
              </div>
            </mat-chip>
          }
        </mat-chip-listbox>
      </div>
    </div>
  </div>
</cs-standard-form>
